<template>
  <div class="root">
    <div class="top">
      <div class="letTop">
        <div style="display: inline-block;width: 39%;">
          <el-radio-group v-model="type" @change="typeChange()">
            <el-radio :label="1">图片</el-radio>
            <el-radio :label="2">PDF</el-radio>
          </el-radio-group>
        </div>
        <span class="warning">{{warning}}</span>
      </div>
      <div class="rightTop">
        <el-button class="OrangeSmBtn" size="small" @click="clear()">重置</el-button>
        <el-button class="BlueSmBtn" size="small" @click="load()">加载</el-button>
        <input ref="ocrFile" type="file" style="display: none" @change="change" :accept="format"/>
      </div>
    </div>

    <el-image v-if="1===type" class="left" fit="contain" :src="blob">
      <div slot="error" style="text-align: center;margin: 0 auto;font-size: 24px;height: 30px;line-height: 30px;">
        选择图片
      </div>
    </el-image>

    <div v-if="2===type" class="left" style="overflow: auto">
      <div v-if="''===blob" style="text-align: center;margin: 0 auto;font-size: 24px;height: 30px;line-height: 30px;">选择PDF文件</div>
      <pdf style="width: 100%;height: 100%" :src="blob" :page="pdfNum" @num-pages="numPages = $event"></pdf>
    </div>
    <div class="center">
      <div v-if="show">
        <span class="pageSpan">当前页：{{pdfNum}}</span><br/>
        <span class="pageSpan">总页数：{{numPages}}</span><br/>
        <el-button class="operateBtn WhiteSmBtn" size="small" @click="prePage()">上一页</el-button><br/>
        <el-button class="operateBtn WhiteSmBtn" size="small" @click="nextPage()">下一页</el-button><br/>
      </div>
      <el-button class="GreenSmBtn" size="small" @click="doOcr()">识别</el-button>
    </div>
    <div class="right" v-loading="loading" element-loading-text="识别中"  element-loading-background="rgba(255, 255, 255, 0.3)">
      <textarea v-model="result">
      </textarea>
    </div>

  </div>


</template>

<script>
  import pdf from 'vue-pdf'
  export default {
    components: {
      pdf,
    },
    data() {
      return {
        type: 1,
        blob: '',
        file: null,
        warning: '图片大小不能超过4M，仅支持jpg/jpeg/png/bmp格式',
        loading: false,
        result: '',
        format: 'image/png,image/jpeg,image/jpg,image/bmp',
        pdfNum: 1,
        numPages: 0,
        show: false,
      }
    },
    methods: {
      clear(){
        this.type = 1;
        this.blob = '';
        this.file = null;
        this.format = "image/png,image/jpeg,image/jpg,image/bmp";
        this.warning = "图片大小不能超过4M，仅支持jpg/jpeg/png/bmp格式";
        this.loading = false;
        this.result = '';
        this.show = false;
        this.pdfNum = 1;
        this.numPages = 0;
        this.$refs.ocrFile.value = '';
      },
      typeChange(){
        this.blob = '';
        this.file = null;
        this.loading = false;
        this.result = '';
        this.show = false;
        this.pdfNum = 1;
        this.numPages = 0;
        this.$refs.ocrFile.value = '';
        if (this.type == 1){
          this.format = "image/png,image/jpeg,image/jpg,image/bmp";
          this.warning = "图片大小不能超过4M，仅支持jpg/jpeg/png/bmp格式";
        }else if (this.type == 2){
          this.format = "application/pdf";
          this.warning = "PDF文件大小不能超过4M";
        }
      },
      change(e) {
        this.pdfNum = 1;
        this.numPages = 0;
        this.file = e.target.files[0];
        if (this.format.indexOf(this.file.type) == -1){
          this.$message.warning("文件格式错误!");
          return;
        }
        this.blob = window.URL.createObjectURL(this.file);
        if (this.type === 2){
          this.show = true;
        }
      },
      load() {
        this.$refs.ocrFile.dispatchEvent(new MouseEvent('click'));
      },
      doOcr() {
        if (this.file) {
          this.loading = true;
          let startTime = new Date();
          let formdata = new FormData();
          formdata.append("file", this.file);
          formdata.append("type",this.type);
          formdata.append("pageNum",this.pdfNum);
          this.$axiospost("operation/ocr", formdata).then((res) => {
            let endTime = new Date();
            let cost = endTime.getTime()-startTime.getTime();
            let str = cost > 1000 ? (cost/1000)+"s" : cost+"ms";
            this.$message.success("耗时" + str);
            this.result = '';
            if (1===this.type){
              res.data.data.words_result.forEach(i => {
                this.result = this.result + i.words + "\n";
              })
            }else if(2===this.type){
              res.data.data.results.forEach(i => {
                console.log(i.words.word)
                this.result = this.result + i.words.word + "\n";
              })
            }
            this.loading = false;
          }).catch(function (error) {
            this.loading = false;
          });

        } else {
          if (1===this.type){
            this.$message.warning("请先选择图片!");
          }else {
            this.$message.warning("请先选择PDF文件!");
          }
        }
      },
      prePage(){
        this.pdfNum = (this.pdfNum-1 < 1) ? 1 : this.pdfNum-1;
      },
      nextPage(){
        this.pdfNum = (this.pdfNum+1 > this.numPages) ? this.numPages : this.pdfNum+1;
      }
    }
  }
</script>

<style scoped>
  .warning {
    display: inline-block;
    width: 52%;
    text-align: right;
    color: red;
  }

  .root {
    width: 100%;
    height: 100%;
    margin: 0;
    padding: 20px 0 0 0;
  }

  .left {
    width: 41%;
    height: 92%;
    display: inline-block;
    border: 1px solid white;
  }

  .right {
    width: 49%;
    height: 92%;
    display: inline-block;
    border: 1px solid white;
  }

  .center {
    position: relative;
    bottom: 45%;
    display: inline-block;
    width: 9%;
    text-align: center
  }

  .top {
    width: 100%;
    height: 6%;
  }

  .letTop {
    width: 45%;
    display: inline-block;
    margin-right: 9.2%;
    padding-top: 8px;
  }

  .rightTop {
    width: 45%;
    display: inline-block;
    text-align: right
  }

  .operateBtn {
    margin-bottom: 20px;
  }

  .operateBtn:hover {
    color: #409EFF;
    border-color: #c6e2ff;
    background-color: #ecf5ff;
  }

  .pageSpan {
    display: inline-block;
    margin-bottom: 20px;
    width: 55%;
  }

  .el-button {
    border: 0px;
  }

  textarea{
    width: 100%;
    color: white;
    height: 100%;
    background-color: #0e0e18;
    font-size: 16px;
    line-height: 24px
  }
</style>



// WEBPACK FOOTER //
// src/components/dynamicRoute3/management/exhibitionHall/ocr/index.vue